

const sidePanReducer = (state = {}, action) => {
  switch (action.type) {
    case "ShowSidePan":
      return Object.assign({}, state, {
        sidePan: action.data,
      });
      break;
    case "ShowEquipmentName":
      return Object.assign({}, state, {
        VendorEquipmentName: action.data,
      });
      break;
    case "MENU_TOGGLE":
      return Object.assign({}, state, {
        menuToggle: action.data,
      });
    case "searchData":
      return Object.assign({}, state, {
        searchData: action.data,
      });
      break;
    case "serviceSearchData":
      return Object.assign({}, state, {
        serviceSearchData: action.data,
      });
      break;
    case "PendingsearchData":
      return Object.assign({}, state, {
        PendingsearchData: action.data,
      });
      break;
    case "SearchCotract":
      return Object.assign({}, state, {
        SearchCotract: action.data,
      });
      break;
    case "SearchBothContract":
      return Object.assign({}, state, {
        SearchBothContract: action.data,
      });
      break;
    case "ShipManagementsearchData":
      return Object.assign({}, state, {
        ShipManagementsearchData: action.data,
      });
      break;
    case "PendingShipsearchData":
      return Object.assign({}, state, {
        PendingShipsearchData: action.data,
      });
      break;
    case "InactiveShipsearchData":
      return Object.assign({}, state, {
        InactiveShipsearchData: action.data,
      });
      break;
    case "SelectedLanguage":
      return Object.assign({}, state, {
        selectedLang: action.data,
      });
      break;
    case "searched":
      return Object.assign({}, state, {
        searched: action.data,
      });
      break;
    case "Pendingsearched":
      return Object.assign({}, state, {
        Pendingsearched: action.data,
      });
      break;
    case "ShowRightPan":
      return Object.assign({}, state, {
        RightPan: action.data,
      });
      break;
    case "ShowShipDetails":
      return Object.assign({}, state, {
        ShowShipDetails: action.data,
      });
      break;
    case "EditShipDetails":
      return Object.assign({}, state, {
        EditShipDetails: action.data,
      });
      break;
    case "ShowEquipmentDetails":
      return Object.assign({}, state, {
        ShowEquipmentDetails: action.data,
      });
      break;
    case "EditEquipmentDetails":
      return Object.assign({}, state, {
        EditEquipmentDetails: action.data,
      });
      break;
    case "ShowMMPLDetails":
      return Object.assign({}, state, {
        ShowMMPLDetailsPane: action.data,
      });
      break;
    case "ShowContractDetailsPane":
      return Object.assign({}, state, {
        ShowContractDetailsPane: action.data,
      });
      break;
    case "ShowServiceUpdatePane":
      return Object.assign({}, state, {
        ShowServiceUpdatePane: action.data,
      });
      break;
    case "Refresh":
      return Object.assign({}, state, {
        Refresh: action.data,
      });
      break;
    case "SubBannerTitle":
      return Object.assign({}, state, {
        SubBannerTitle: action.data,
      });
      break;
    case "Client Dashboard":
      return Object.assign({}, state, {
        sidePan: action.data,
        SubBannerTitle: "Client Dashboard",
      });
      break;
    case "MMPL Dashboard":
      return Object.assign({}, state, {
        sidePan: action.data,
      });
      break;
    case "Contracts":
      return Object.assign({}, state, {
        sidePan: action.data,
      });
      break;
    case "MD Library":
      return Object.assign({}, state, {
        sidePan: action.data,
        SubBannerTitle: "MD Library",
      });
      break;
    case "Shipment Library":
      return Object.assign({}, state, {
        sidePan: action.data,
        SubBannerTitle: "Ship Equipment Status",
      });
      break;
    case "Reports":
      return Object.assign({}, state, {
        sidePan: action.data,
        SubBannerTitle: "Reports",
      });
      break;
    case "User":
      return Object.assign({}, state, {
        sidePan: action.data,
        SubBannerTitle: "User",
      });
      break;
    case "ShowMISidePan":
      return Object.assign({}, state, {
        ShowMISidePan: action.data,
        ShowRDSidePan: false,
        ShowEURegSidePan: false,
      });
      break;
    case "ShowRDSidePan":
      return Object.assign({}, state, {
        ShowMISidePan: false,
        ShowRDSidePan: action.data,
        ShowEURegSidePan: false,
      });
      break;
    case "ShowEURegSidePan":
      return Object.assign({}, state, {
        ShowMISidePan: false,
        ShowRDSidePan: false,
        ShowEURegSidePan: action.data,
      });
      break;
    case "GetMDSearchSuccess":
      return Object.assign({}, state, {
        arraylist: action.data,
        MDDeleteSuccess: false,
      });
    case "MDSearchIsTrue":
      return Object.assign({}, state, {
        isMDSearch: true,
        MDSearchData: action.data ?? null,
      });
      break;
    case "GetMDDetailFailure":
      return Object.assign({}, state, {
        e: action.data,
      });
      break;
    case "GetMDDetailSuccess":
      return Object.assign({}, state, {
        mdDetailList: action.data,
      });
      break;
    case "GetOthersMISuccess":
      return Object.assign({}, state, {
        MIOthersList: action.data,
      });
      break;
    case "GetOthersMIFailure":
      return Object.assign({}, state, {
        ee: action.data,
      });
      break;
    case "GetOthersEUSuccess":
      return Object.assign({}, state, {
        MIEuList: action.data,
      });
      break;
    case "GetOthersEUFailure":
      return Object.assign({}, state, {
        ee: action.data,
      });
      break;
    case "PostMaterialDeclarationSuccess":
      return Object.assign({}, state, {
        declarationID: action.data,
      });
      break;
    case "PostMaterialDeclarationFailure":
      return Object.assign({}, state, {
        ee: action.data,
      });
      break;
    case "EmptyMdDetailList":
      return Object.assign({}, state, {
        mdDetailList: [],
      });
      break;
    case "ClearMdDetailList":
      return Object.assign({}, state, {
        mdDetailList: [],
      });
      break;
    case "MDDeleteSuccess":
      return Object.assign({}, state, {
        MDDeleteSuccess: true,
        sidePan: false,
      });
      break;
    case "getMDRelatedDocuments":
      return Object.assign({}, state, {
        RDList: action.data,
      });
      break;
    case "AttchmentUploaded":
      return Object.assign({}, state, {
        attachmentDetail: action.data,
        isAttachment: true,
      });
      break;
    case "GAttchmentUploaded":
      return Object.assign({}, state, {
        GattachmentDetail: action.data,
        isAttachment: true,
      });
      break;
    case "EquipManualAttchmentUploaded":
      return Object.assign({}, state, {
        EquipManualattachmentDetail: action.data,
        isAttachment: true,
      });
      break;
    case "SDocAttchmentUploaded":
      return Object.assign({}, state, {
        MdAttachment: action.data,
      });
      break;
    case "SMDDeleteSuccess":
      return Object.assign({}, state, {
        SMDisDeleted: true,
      });
      break;
    case "SMDupdateSuccess":
      return Object.assign({}, state, {
        SMDisUpdated: true,
      });
      break;
    case "SMDUpdate":
      return Object.assign({}, state, {
        SMDisDeleted: action.data,
      });
      break;
    case "SMDDelete":
      return Object.assign({}, state, {
        SMDisDeleted: action.data,
      });
      break;
    case "GetMaterialDetailsSuccess":
      return Object.assign({}, state, {
        MInfoList: action.data,
      });
      break;
    case "GetMaterialDetailsFailure":
      return Object.assign({}, state, {
        arraylist: action.data,
      });
      break;
    case "GetMDRemarkSuccess":
      return Object.assign({}, state, {
        RemarksList: action.data,
      });
      break;
    case "GetMDRemarkFailure":
      return Object.assign({}, state, {
        arraylist: action.data,
      });
      break;
    case "PostMDRemarkSuccess":
      return Object.assign({}, state, {
        MDRemarksList: action.data,
      });
      break;
    case "PostMDRemarkFailure":
      return Object.assign({}, state, {
        arraylist: action.data,
      });
      break;
    case "GetReportListSuccess":
      return Object.assign({}, state, {
        ReportList: action.data,
      });
      break;
    case "IsEditUser":
      return Object.assign({}, state, {
        IsEditUser: action.data,
      });
    case "IsSMDEdit":
      return Object.assign({}, state, {
        IsSMDEdit: action.data,
      });
      break;
    case "SMDEditing":
      return Object.assign({}, state, {
        SMDEditing: action.data,
      });
      break;
    case "ErrorMessage":
      return Object.assign({}, state, {
        ErrorMessage: action.data,
      });
      break;
    case "AuthenticatedUserInformation":
      return Object.assign({}, state, {
        isAuthenticated: action.data.isAuthenticated,
        userDisplayName: action.data.displayName,
        userDetail: action.data.user,
      });
      break;
    case "GetSMDSearchSuccess":
      return Object.assign({}, state, {
        SMDListData: action.data,
      });
      break;
    case "SMDAttchmentUploadSuccess":
      return Object.assign({}, state, {
        SMDAttachmentData: action.data,
      });
      break;
    case "SMDAttchmentClear":
      return Object.assign({}, state, {
        SMDAttachmentData: "",
      });
      break;
    case "SMDPostSuccessfull":
      return Object.assign({}, state, {
        IsSMDDataAdded: action.data,
      });
      break;
    case "getUserDataSuccess":
      return Object.assign({}, state, {
        userList: action.data,
      });
      break;
    case "UpdateUserSuccess":
      return Object.assign({}, state, {
        isUserUpdated: action.data,
      });
      break;
    case "UserDeleteSuccess":
      return Object.assign({}, state, {
        isUserDeleted: action.data,
      });
      break;
    case "PostUserSuccess":
      return Object.assign({}, state, {
        isUserAdded: action.data,
      });
      break;
    case "UserAuthenticationSuccess":
      return Object.assign({}, state, {
        IsAuthenticatedUser: action.data,
      });
      break;
    case "ADUsersSuccess":
      return Object.assign({}, state, {
        ADUsersList: action.data,
      });
    case "getClientShipCountSuccess":
      return Object.assign({}, state, {
        ClientShipCount: action.data,
      });
      break;
    case "getClientShipDetailSuccess":
      return Object.assign({}, state, {
        ClientShipDetails: action.data,
      });
      break;
    case "UserRole":
      return Object.assign({}, state, {
        UserRole: action.data
      })
      break;
    case "AuthenticatedUserInformation":
      return Object.assign({}, state, {
        isAuthenticated: action.data.isAuthenticated,
        userDetail: action.data
      })
      break;
    case "getStaffListSuccess":
      return Object.assign({}, state, {
        StaffList: action.data,
      });
      break;
    case "getStaffListFailure":
      return Object.assign({}, state, {
        StaffList: action.data,
      });
      break;
    case "postStaffDetailSuccess":
      return Object.assign({}, state, {
        postStaffDetail: action.data,
      });
      break;
    case "postStaffDetailFailure":
      return Object.assign({}, state, {
        postStaffDetail: action.data,
      });
      break;
    case "putStaffDetailSuccess":
      return Object.assign({}, state, {
        putStaffDetail: action.data,
      });
      break;
    case "putStaffDetailFailure":
      return Object.assign({}, state, {
        putStaffDetail: action.data,
      });
      break;
    // case "getServiceTypeListSuccess":
    //   return Object.assign({}, state, {
    //     ServiceTypeList: action.data,
    //   });
    //   break;
    case "getServiceTypeListFailure":
      return Object.assign({}, state, {
        ServiceTypeList: action.data,
      });
      break;
    case "getEquipmentServiceTypeListSuccess":
      return Object.assign({}, state, {
        EquipmentServiceTypeList: action.data,
      });
      break;
    case "getEquipmentServiceTypeListFailure":
      return Object.assign({}, state, {
        EquipmentServiceTypeList: action.data,
      });
      break;
    case "EquipmentServiceTypeDetail":
      return Object.assign({}, state, {
        EquipmentServiceTypeDetail: action.data,
      });
    case "GET_SERVICEUPDATE_EQUIPMENTTYPE":
      return Object.assign({}, state, {
        EquipmentServiceUpdateType: action.data,
      });
      break;
    case "staffSearch":
      return Object.assign({}, state, {
        staffSearch: action.data,
      });
      break;
    default: {
      return state;
    }
  }
};
export default sidePanReducer;
